// Esquemas de formulário do módulo (zod) e conversões para o contrato — fora dos arquivos de componente para o Fast
// Refresh (`react-refresh/only-export-components`) e para os testes de unidade. As mensagens são chaves do namespace
// `authz` (`forms.errors.*`), traduzidas por `useFormErrorTranslator`.
import { z } from 'zod';

import type { GrantAssignmentInput } from '../api/queries';

export const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

export const grantSchema = z.object({
  userId: z.string().regex(UUID, 'forms.errors.uuid'),
  roleCode: z.string().min(1, 'forms.errors.required'),
  scopeType: z.enum(['Network', 'Tenant', 'Site', 'Study'], { message: 'forms.errors.required' }),
  scopeId: z.string().refine((value) => value === '' || UUID.test(value), 'forms.errors.uuid'),
  tenantId: z.string().refine((value) => value === '' || UUID.test(value), 'forms.errors.uuid'),
  effectiveFrom: z
    .string()
    .refine((value) => value === '' || ISO_DATE.test(value), 'forms.errors.date'),
  effectiveTo: z
    .string()
    .refine((value) => value === '' || ISO_DATE.test(value), 'forms.errors.date'),
  reason: z.string().trim().min(1, 'forms.errors.required').max(500, 'forms.errors.tooLong'),
});

export type GrantFormValues = z.infer<typeof grantSchema>;

/** Valores do formulário → corpo de `POST …/authz/assignments` (escopo `Network` sem id; no tenant o id padrão é o próprio). */
export function toGrantInput(
  values: GrantFormValues,
  tenantId: string | null,
): GrantAssignmentInput {
  const scopeId = values.scopeType === 'Network' ? null : values.scopeId || tenantId;
  return {
    userId: values.userId,
    roleCode: values.roleCode,
    scopeType: values.scopeType,
    scopeId,
    tenantId: values.scopeType === 'Study' ? values.tenantId || tenantId : null,
    effectiveFrom: values.effectiveFrom || null,
    effectiveTo: values.effectiveTo || null,
    reason: values.reason,
  };
}

export const breakGlassSchema = z.object({
  scopeId: z.string().regex(UUID, 'forms.errors.uuid'),
  reason: z
    .string()
    .trim()
    .min(10, 'forms.errors.reasonTooShort')
    .max(1000, 'forms.errors.tooLong'),
});

export type BreakGlassFormValues = z.infer<typeof breakGlassSchema>;
